// CMS GTM for Icon Tout Block
export const gtmEventTypes = {
  CLICK_LINK: 'CMS-ICONTOUTBLOCK-001',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_LINK]: ({CMSGroupGTM, blockTitle = '', ctaName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_LINK,
    event: 'reactjs.event',
    pageAction: ctaName
      ? `${CMSGroupGTM.action} "${blockTitle &&
      blockTitle.toUpperCase()}" - Clicked "${ctaName.toUpperCase()}"`
      : CMSGroupGTM.action,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/icon-tout-block-duck.js